import "./style.css";
import React, { useState, useMemo } from "react";

import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import Container from "components/Container";
import TextBox from "components/TextBox";
import ProjectLink from "components/ProjectLink";

export default function ExpandableCard({
	expCardId,
	expCardTopId,
	expCardContClass,
	expCardTopClass,
	expCardIconClass,
	expCardTitleClass,
	expCardTitleText,
	expCardInfoClass,
	expCardInfoText,
	expCardInfoIconClass,
	expCardInfoIcon,
	expCardImageClass,
	expCardImageSrc,
	expCardCodeLangClass,
	expCardCodeLang,
	expCardBodyClass,
	expCardBodyText,
	expCardGitLink,
	expCardWebLink,
}) {
	const [cardOpen, setCardOpen] = useState(false);
	const codeLangArray = useMemo(() => {
		if (expCardCodeLang && expCardCodeLang.trim() !== "") {
			const stringToArray = expCardCodeLang.split(" ");
			return stringToArray;
		}
	}, [expCardCodeLang]);

	function openCard() {
		setCardOpen(!cardOpen);
	}

	return (
		<Container
			containerId={expCardId}
			containerClass={`exp-container ${expCardContClass}`}
		>
			<Container
				containerId={expCardTopId}
				containerClass={
					expCardImageSrc
						? `${
								cardOpen
									? `exp-card-image-container-active ${expCardTopClass}`
									: `exp-card-image-container ${expCardTopClass}`
						  }`
						: `${
								cardOpen
									? `exp-card-container-active ${expCardTopClass}`
									: `exp-card-container ${expCardTopClass}`
						  }`
				}
				onClick={openCard}
			>
				<div className="exp-card-top">
					<TextBox
						textClass={`exp-card-title ${expCardTitleClass}`}
						text={expCardTitleText}
						faIcon={cardOpen ? faMinus : faPlus}
						faIconClass={`exp-card-icon ${expCardIconClass}`}
					/>
					{expCardGitLink || expCardWebLink ? (
						<ProjectLink
							gitLink={expCardGitLink}
							webLink={expCardWebLink}
						/>
					) : (
						<TextBox
							textClass={`exp-card-info ${expCardInfoClass}`}
							text={expCardInfoText}
							faIcon={expCardInfoIcon}
							faIconClass={expCardInfoIconClass}
						/>
					)}
				</div>
				{expCardImageSrc && (
					<Container>
						<img
							alt="project-image-alt"
							src={expCardImageSrc}
							className={`project-image ${expCardImageClass}`}
							onClick={openCard}
						/>
						<Container containerClass="exp-code-lang-container">
							{codeLangArray &&
								codeLangArray.length > 0 &&
								codeLangArray.map((codeLang, arrKey) => {
									return (
										<TextBox
											key={arrKey}
											text={codeLang}
											textClass={
												cardOpen
													? `code-language-active ${expCardCodeLangClass}`
													: `code-language ${expCardCodeLangClass}`
											}
										/>
									);
								})}
						</Container>
					</Container>
				)}
			</Container>
			<TextBox
				textClass={
					cardOpen
						? `exp-card-body show-card ${expCardBodyClass}`
						: `hide-card`
				}
				text={expCardBodyText}
			/>
		</Container>
	);
}
